(function() {
  var grids = document.querySelectorAll('.komfy-bundle-grid__cards');
  grids.forEach(function(grid) {
    var cards = grid.querySelectorAll('.komfy-product-card');
    if (cards.length === 0) return;

    function setActive(activeCard) {
      cards.forEach(function(c) {
        c.classList.remove('komfy-product-card--active');
        var video = c.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
      activeCard.classList.add('komfy-product-card--active');
      var activeVideo = activeCard.querySelector('video');
      if (activeVideo) {
        activeVideo.currentTime = 0;
        activeVideo.play();
      }
    }

    // Pause all videos initially, then activate first card
    cards.forEach(function(c) {
      var video = c.querySelector('video');
      if (video) video.pause();
    });
    setActive(cards[0]);

    cards.forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        setActive(card);
      });
    });
  });
})();
